export default {
    data() {
        return {
            warningClass: function(items) { return items['info_aportes/anulado'] == 1 ? true : false },
            tableGBoptions: {
                modals: [{
                        modal: "Editar",
                        icon: "pencil",
                        title: "Editar Registro",
                        variant: 'primary',
                        showFtn: function(value) {
                            if (value['info_aportes/anulado'] === 0 && value['archivo_plano'] === null && value['autorizar'].length === 0) { return true }
                            return false;
                        },
                        movil: true
                    },
                    {
                        modal: "Anular",
                        icon: "x-circle",
                        title: "Anular Registro",
                        variant: 'danger',
                        showFtn: function(value) {
                            if ((value['info_aportes/anulado'] === 0 && value['autorizar'].length === 0 && value['archivo_plano'] === null && value['info_aportes/id_list_mes'] === value['periodo/mes'] && value['info_aportes/id_list_ano'] === value['periodo/ano']) || (value['info_aportes/anulado'] === 0 && value['info_aportes/servicios'] === 2 && value['autorizar'].length === 0)) { return true }
                            return false;
                        },
                    },
                ]
            },

            tableGBSearch: ['info_aportes/documento', 'info_aportes/name'],

            tableGBItems: [{
                    thead: { th: 'Documento', sort: null, sortTable: 'info_aportes/documento' },
                    tbody: { td: ['info_aportes/documento', ] }
                },
                {
                    thead: { th: 'Nombre', sort: null, sortTable: 'info_aportes/name', movil: true },
                    tbody: { td: ['info_aportes/name'] }
                },
                {
                    thead: { th: 'Razón', },
                    tbody: { td: ['datos_razon/name'], }
                },
                {
                    thead: { th: 'Asesor', },
                    tbody: { td: ['datos_asesor/name'], }
                },
                {
                    thead: { th: 'Fecha', },
                    tbody: { td: ['info_aportes/fecha'], }
                },
                {
                    thead: { th: 'Valor', },
                    tbody: { td: ['info_aportes/valor'] }
                },
                {
                    thead: { th: 'Periodo', },
                    tbody: { td: ['list_mes/name', 'info_aportes/id_list_ano'] }
                },
                {
                    thead: { th: 'Forma', },
                    tbody: { td: ['list_forma/name'] }
                },
                {
                    thead: { th: 'Cuenta', },
                    tbody: { td: ['list_cuentas/name', 'info_aportes/consignacion'], show: { td: 'info_aportes/id_list_forma', compare: 1, else: '' } }
                },
                {
                    thead: { th: 'Registro', },
                    tbody: { td: ['info_aportes/id'], link: '/api/pdf/registroaportes', show: { td: 'info_aportes/anulado', compare: 0, else: 'Anulado' } }
                },
            ],

        }
    },
}